import { GENERIC_SAVE_ERROR } from "./pharmacistProfileErrors";

// ITAM-2746 error mapping for the missed-calls panel.

const status = (error: unknown): number | undefined =>
  typeof error === "object" && error !== null
    ? (error as { response?: { status?: number } }).response?.status
    : undefined;

/** Shown in place of the rows only on a FIRST load failure (D9). */
export const MISSED_CALLS_LOAD_ERROR =
  "Propušteni pozivi trenutno nisu dostupni.";

export const MISSED_CALLS_REFRESH_ERROR =
  "Osvežavanje liste nije uspelo. Prikazani su poslednji učitani podaci.";

/** 409 and 404 both mean the row on screen is stale, so the caller also refetches. */
export const shouldRefetchAfterContactError = (error: unknown): boolean => {
  const code = status(error);
  return code === 404 || code === 409;
};

/**
 * Describes what the WRITE did, and nothing else. It must not claim the list
 * was refreshed: the reconciliation GET has not settled when this is set, and
 * may fail (D9). Refresh outcome is reported separately by the load effect.
 */
export const mapContactError = (error: unknown): string => {
  switch (status(error)) {
    case 409:
      return "Poziv više nije u listi propuštenih.";
    case 404:
      return "Poziv više ne postoji.";
    default:
      return GENERIC_SAVE_ERROR;
  }
};
